;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { CanaryClient } from '@qogita/deprecated-canary-client'
import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { getStocklistSourceNamesQueryKey } from 'src/deprecated/utils/queryKey'

const getStocklistSourceNames = ({
  filterExpired,
  canaryClient,
}: {
  filterExpired?: boolean
  canaryClient: CanaryClient
}) => canaryClient.getStocklistSourceNames({ filterExpired })

const getStocklistSourceNamesQueryOptions = ({
  filterExpired,
  canaryClient,
}: {
  filterExpired?: boolean
  canaryClient: CanaryClient
}) =>
  // TODO: resolve this by moving to RSC or adding the missing dependency
  // oxlint-disable-next-line @tanstack/query/exhaustive-deps
  queryOptions({
    queryKey: getStocklistSourceNamesQueryKey(filterExpired),
    queryFn: () => getStocklistSourceNames({ filterExpired, canaryClient }),
  })

export const useGetStocklistSourceNames = ({
  enabled,
  filterExpired,
}: {
  enabled?: boolean
  filterExpired?: boolean
} = {}) => {
  const canaryClient = useCanaryClient()

  // oxlint-disable-next-line @tanstack/query/no-rest-destructuring
  const { data, ...rest } = useQuery({
    ...getStocklistSourceNamesQueryOptions({ filterExpired, canaryClient }),
    enabled,
  })

  return {
    ...rest,
    stocklistSources: data ?? [],
    totalResults: data?.length ?? 0,
  }
}
